import React, { createContext, useContext, useState } from 'react';
import appData from '../data/data.json';

const AuthContext = createContext(null);

const SESSION_DURATION_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

const isSessionValid = () => {
    const loginTime = localStorage.getItem('bd_auth_time');
    if (!loginTime) return false;
    return Date.now() - parseInt(loginTime, 10) < SESSION_DURATION_MS;
};

export const AuthProvider = ({ children }) => {
    const [isLoggedIn, setIsLoggedIn] = useState(() => {
        return localStorage.getItem('bd_auth') === 'true' && isSessionValid();
    });

    const login = (username, password) => {
        if (username === appData.auth.username && password === appData.auth.password) {
            localStorage.setItem('bd_auth', 'true');
            localStorage.setItem('bd_auth_time', Date.now().toString());
            setIsLoggedIn(true);
            return true;
        }
        return false;
    };

    const logout = () => {
        localStorage.removeItem('bd_auth');
        localStorage.removeItem('bd_auth_time');
        setIsLoggedIn(false);
    };

    return (
        <AuthContext.Provider value={{ isLoggedIn, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
